import React, { useEffect, useState } from 'react';
import ProfileHeader from '../profile/profile-header';
import useDashboardContext from 'contexts/dashboard.context';
import { UserInfoType } from './types';
import { toast } from 'react-toastify';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import ProfileInfo from './profile-info';
import { STORAGE_KEYS } from 'utils/constants';
import { handleApiError } from 'utils/functions';
const EditProfile = () => {
  const { setBackLinkTitle, setIsBackLink, activeCompany, refetchActiveCompany } =
    useDashboardContext();

  const [loading, setLoading] = useState(false);

  const [imgSrc, setImgSrc] = useState(activeCompany.logo);
  const companyId = activeCompany?.id;

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to Profile');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  const PERSONAL_INFO: UserInfoType[] = [
    {
      label: 'First name',
      value: localStorage.getItem(STORAGE_KEYS.FIRST_NAME),
      name: 'first_name'
    },
    {
      label: 'Last name',
      value: localStorage.getItem(STORAGE_KEYS.LAST_NAME),
      name: 'last_name'
    },
    {
      label: 'Email',
      value: localStorage.getItem(STORAGE_KEYS.EMAIL),
      name: 'email',
      disabled: true
    }
  ];

  const COMPANY_INFO: UserInfoType[] = [
    {
      label: 'Company name',
      value: activeCompany.name,
      name: 'name',
      disabled: true
    },
    {
      label: 'Company address',
      value: activeCompany.address,
      name: 'address'
    },
    {
      label: 'CAC number',
      value: activeCompany.cac,
      name: 'cac',
      disabled: true
    },
    {
      label: 'Company mail',
      value: activeCompany.email,
      name: 'email',
      disabled: true
    }
  ];
  const [personalInfoData, setPersonalInfoData] = useState(PERSONAL_INFO);
  const [companyInfoData, setCompanyInfoData] = useState(COMPANY_INFO);
  const [isPersonalInfoEdited, setIsPersonalInfoEdited] = useState(false);
  const [isCompanyInfoEdited, setIsCompanyInfoEdited] = useState(false);

  useEffect(() => {
    setImgSrc(activeCompany.logo);
    setPersonalInfoData(PERSONAL_INFO), setCompanyInfoData(COMPANY_INFO);
  }, [activeCompany]);

  useEffect(() => {
    isDisabled();
  }, [personalInfoData, companyInfoData]);

  const handlePersonalInfoForm = (e: any, i: number) => {
    setIsPersonalInfoEdited(true);
    const { value } = e.target;
    personalInfoData[i].value = value;
    setPersonalInfoData([...personalInfoData]);
  };

  const handleCompanyInfoForm = (e: any, i: number) => {
    setIsCompanyInfoEdited(true);

    const { value } = e.target;
    companyInfoData[i].value = value;
    setCompanyInfoData([...companyInfoData]);
  };

  const updatePersonalDetails = async () => {
    if (!companyId) return;
    const payload: any = {};
    personalInfoData
      .filter(({ disabled }) => disabled !== true)
      ?.map(({ name, value }) => (payload[name] = value));
    try {
      const res = await apiService.put('member/update-user', {
        data: payload
      });
      if (res?.data?.data) {
        toast(<ToastMessage type='success' message='Personal Information updated successfully' />);
        localStorage.setItem(STORAGE_KEYS.FIRST_NAME, payload.first_name);
        localStorage.setItem(STORAGE_KEYS.LAST_NAME, payload.last_name);
      }
    } catch (err) {
      handleApiError(err);
    }
  };
  const updateCompanyDetails = async () => {
    if (!companyId) return;
    const payload: any = {};
    companyInfoData
      ?.filter(({ disabled }) => disabled !== true)
      ?.map(({ name, value }) => (payload[name] = value));
    payload.logo = imgSrc;
    payload.company_id = companyId;
    try {
      await apiService.put('company/update', { data: payload });
      toast(<ToastMessage type='success' message='Company Information updated successfully' />);
      refetchActiveCompany();
    } catch (err) {
      handleApiError(err);
    }
  };
  const isDisabled = () => {
    const comapny_info_payload: Record<string, unknown> = {};
    const personal_info_payload: Record<string, unknown> = {};

    companyInfoData
      ?.filter(({ disabled }) => disabled !== true)
      ?.forEach(({ name, value }) => {
        comapny_info_payload[name] = value;
      });

    personalInfoData
      ?.filter(({ disabled }) => disabled !== true)
      ?.forEach(({ name, value }) => {
        personal_info_payload[name] = value;
      });

    const personalInfoEdited =
      personal_info_payload?.first_name === localStorage.getItem(STORAGE_KEYS.FIRST_NAME) &&
      personal_info_payload?.last_name === localStorage.getItem(STORAGE_KEYS.LAST_NAME);
    setIsCompanyInfoEdited(comapny_info_payload?.address === activeCompany.address);
    setIsPersonalInfoEdited(personalInfoEdited);
  };
  const updateProfile = () => {
    setLoading(true);
    if (!isCompanyInfoEdited) {
      updateCompanyDetails();
    }
    if (!isPersonalInfoEdited) {
      updatePersonalDetails();
    }
    setLoading(false);
  };
  return (
    <div className='w-[95%] max-w-[700px] space-y-8'>
      <ProfileHeader imgSrc={imgSrc} setImgSrc={setImgSrc} />
      <ProfileInfo
        handleChange={handlePersonalInfoForm}
        list={personalInfoData}
        title='Personal Information'
      />
      <ProfileInfo
        handleChange={handleCompanyInfoForm}
        list={companyInfoData}
        title='Company Information'
      />
      <div className='flex-end'>
        <Button
          className='w-[160px]'
          color='primary'
          loading={loading}
          small
          disabled={isPersonalInfoEdited && isCompanyInfoEdited && imgSrc === activeCompany.logo}
          variant='block'
          onClick={updateProfile}>
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default EditProfile;
